import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import styles from './CustomTab.module.scss';

export default function CustomTab({ items, width, tab, setTab }) {
	const handleClick = (e) => {
		var id = e.currentTarget.dataset.activeid;

		console.log('handleClick', id);
		setTab(Number(id));
	};

	return (
		<Grid container className={styles.tabGroup} direction='row'>
			{items.map((item, index) => (
				<Grid
					item
					className={`${styles.tabItem} ${
						Number(tab) === Number(index) ? styles.active : ''
					}`}
					style={{ width: width }}
					onClick={(e) => handleClick(e)}
					data-activeid={index}
					key={index}
				>
					{item}
				</Grid>
			))}
		</Grid>
	);
}
